// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3nZq_","container":"Footer_container__2mCKx","spacer":"Footer_spacer__17IOj"};